<template>
  <el-row>
    <el-card shadow="none"
             class="form-card mb-15">
      <el-form :inline="true"
               :model="searchForm"
               ref="search_form"
               class="search-form">
        <el-form-item label="人员姓名："
                      prop="person_name">
          <el-input v-model.trim="searchForm.person_name"
                    placeholder="人员姓名"></el-input>
        </el-form-item>
        <el-form-item label="部门："
                      prop="dep_names">
          <el-input v-model.trim="searchForm.dep_names"
                    placeholder="部门"></el-input>
        </el-form-item>
        <el-form-item label="是否异常："
                      prop="stat_work">
          <el-select v-model="searchForm.stat_work"
                     placeholder="是否异常">
            <el-option label="全部"
                       value=""></el-option>
            <el-option label="异常"
                       value="0"></el-option>
            <el-option label="正常"
                       value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考勤日期：">
          <el-date-picker v-model="searchForm.time"
                          value-format="yyyy-MM-dd"
                          type="daterange"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="searchSubmit('search_form')">查询
          </el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetForm('search_form')">重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-row>
      <el-button v-has="'/work_report/export'"
                 type="primary"
                 @click="handleExport">考勤导出</el-button>
      <el-button v-has="'/work_report/record_export'"
                 type="primary"
                 @click="handleRecordExport">记录导出</el-button>
    </el-row>
    <el-card shadow="none"
             class="mt-15">
      <el-table max-height="575"
                ref="multipleTable"
                :data="tableData">
        <el-table-column type="index"
                         label="序号"
                         width="60"></el-table-column>
        <el-table-column v-for="(item, index) in tableTitle"
                         :key="index"
                         :label="item.name"
                         :prop="item.prop"
                         :min-width="item.width"
                         :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <template v-if="item.prop === 'stat_come'">
              <el-tag v-if="scope.row[item.prop] === '1'"
                      type="success">正常</el-tag>
              <el-tag v-else-if="scope.row[item.prop] === '2'"
                      type="danger">迟到</el-tag>
              <el-tag v-else
                      type="info">未打卡</el-tag>
            </template>
            <template v-else-if="item.prop === 'stat_goback'">
              <el-tag v-if="scope.row[item.prop] === '1'"
                      type="success">正常</el-tag>
              <el-tag v-else-if="scope.row[item.prop] === '2'"
                      type="danger">早退</el-tag>
              <el-tag v-else
                      type="info">未打卡</el-tag>
            </template>
            <template v-else-if="item.prop === 'stat_work'">
              <el-tag v-if="scope.row[item.prop] === '1'"
                      type="success">正常</el-tag>
              <el-tag v-else-if="scope.row[item.prop] === '0'"
                      type="danger">异常</el-tag>
            </template>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :total="pagination.total"
                  :pageSize="pagination.perPage"
                  @handleSizeChange="handleSizeChange"
                  @handleCurrent="handleCurrentChange"></Pagination>
    </el-card>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
//import utils from '@/common/utils'
import Pagination from '@/components/pagination/Pagination'
export default {
  components: { Pagination },
  data() {
    return {
      searchForm: {
        person_name: '',
        dep_names: '',
        stat_work: '',
        time: []
      },
      tableTitle: [
        {
          prop: 'dep_names',
          name: '部门名称',
          width: '120'
        },
        {
          prop: 'person_name',
          name: '人员姓名',
          width: '100'
        },
        {
          prop: 'work_date',
          name: '考勤日期',
          width: '120'
        },
        {
          prop: 'work_come',
          name: '上班时间',
          width: '100'
        },
        {
          prop: 'stat_come',
          name: '是否迟到',
          width: '100'
        },
        {
          prop: 'work_goback',
          name: '下班时间',
          width: '100'
        },
        {
          prop: 'stat_goback',
          name: '是否早退',
          width: '100'
        },
        {
          prop: 'stat_work',
          name: '考勤情况',
          width: '100'
        }
      ],
      tableData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取列表
    getList() {
      const { perPage, currentPage } = this.pagination
      const { searchForm } = this
      let datas = {
        person_name: searchForm.person_name,
        dep_names: searchForm.dep_names,
        stat_work: searchForm.stat_work,
        startTime: searchForm.time.length ? searchForm.time[0] : '',
        endTime: searchForm.time.length ? searchForm.time[1] : ''
      }
      fetch
        .getWorkRecordList({
          perPage: perPage,
          currentPage: currentPage,
          ...datas
        })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.pagination.total = Number(data.total)
              this.tableData = data.list
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },
    // 搜索提交
    searchSubmit() {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.getList()
    },
    resetForm(formName) {
      //if (window.event.ctrlKey) alert('ctrl')
      //else alert('no ctrl')
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.searchForm.time = []
      this.$refs[formName].resetFields()
      this.getList()
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    // 导出
    handleExport() {
      const { searchForm } = this
      let datas = {
        person_name: searchForm.person_name,
        dep_names: searchForm.dep_names,
        stat_work: searchForm.stat_work,
        startTime: searchForm.time.length ? searchForm.time[0] : '',
        endTime: searchForm.time.length ? searchForm.time[1] : ''
      }
      fetch.exportWork({ ...datas }, { responseType: 'blob' }).then((data) => {
        if (data.res.type == 'application/octet-stream') {
          var blob = new Blob([data.res])
          //let date = utils.format(new Date(), 'yyyy-MM-dd')
          let date = this.searchForm.time[0] + '至' + this.searchForm.time[1]
          let filename = '考勤报表_' + date + '.xls'
          var aEle = document.createElement('a')
          let url = URL.createObjectURL(blob)
          aEle.href = url
          aEle.download = filename
          aEle.click()
          window.URL.revokeObjectURL(url)
        } else {
          const reader = new FileReader()
          let parseObj = null
          reader.readAsText(data.res, 'utf-8')
          reader.onload = function () {
            parseObj = JSON.parse(reader.result)
            alert(parseObj.message)
            //this.$message.error(errmsg)
          }
        }
      })
    },

    handleRecordExport() {
      const { searchForm } = this
      let datas = {
        person_name: searchForm.person_name,
        dep_names: searchForm.dep_names,
        stat_work: searchForm.stat_work,
        startTime: searchForm.time.length ? searchForm.time[0] : '',
        endTime: searchForm.time.length ? searchForm.time[1] : ''
      }
      fetch.exportRecordWork({ ...datas }, { responseType: 'blob' }).then((data) => {
        if (data.res.type == 'application/octet-stream') {
          var blob = new Blob([data.res])
          //let date = utils.format(new Date(), 'yyyy-MM-dd')
          let date = this.searchForm.time[0] + '至' + this.searchForm.time[1]
          let filename = '考勤打卡记录_' + date + '.xls'
          var aEle = document.createElement('a')
          let url = URL.createObjectURL(blob)
          aEle.href = url
          aEle.download = filename
          aEle.click()
          window.URL.revokeObjectURL(url)
        } else {
          const reader = new FileReader()
          let parseObj = null
          reader.readAsText(data.res, 'utf-8')
          reader.onload = function () {
            parseObj = JSON.parse(reader.result)
            alert(parseObj.message)
          }
        }
      })
    }
  }
}
</script>

<style lang="less">
</style>
